export default "__VITE_ASSET__01622b0d__"